var _style, _path, _path2, _ellipse, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgServerRecord = function SvgServerRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "server_record_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".server_record_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "server_record_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "server_record_svg__st1",
    d: "M12.01 12c2.73 0 4.95 2.24 4.95 5s-2.22 5-4.95 5-4.95-2.24-4.95-5 2.22-5 4.95-5m0-2c-3.83 0-6.92 3.13-6.92 7s3.1 7 6.92 7c3.83 0 6.92-3.13 6.92-7s-3.1-7-6.92-7z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "server_record_svg__st1",
    cx: 12.01,
    cy: 17,
    rx: 2.89,
    ry: 2.92
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "server_record_svg__st1",
    d: "M20.64 8.38c.25-1.31.2-2.74-.46-4.26-.92-2.15-2.79-3.76-4.96-4.06-3-.42-5.65 1.45-6.72 4.22-.35-.15-.74-.23-1.14-.23-1.83 0-3.32 1.62-3.32 3.61 0 .29.04.56.1.83-.8-.2-1.68-.18-2.74.75-.78.69-1.37 1.7-1.36 2.8.02 1.98 1.49 3.57 3.32 3.57h.94c.65-3.75 3.89-6.6 7.78-6.6s7.13 2.85 7.78 6.6h.6c1.55 0 3.02-1.07 3.38-2.72.54-2.39-1.1-4.51-3.2-4.51z"
  })));
};
export default SvgServerRecord;